import { SynchronizationTime } from "../../../ExtaLife";
import { DeviceConfigParams } from "../../DeviceConfigParams";

export class Rck21ConfigParams extends DeviceConfigParams {
    ReedSwitchMode: ReedSwitchOperationMode = ReedSwitchOperationMode.ShortingOnOpeningOff;
    SyncTime: SynchronizationTime = 720;
    LogicNegation: boolean = false;
}

/**
 * Hall state configuration
 */
export enum ReedSwitchOperationMode {
    TimeConditionMode = 1,
    ShortingSwitchOpeningNoResp = 2,
    ShortingOnOpeningOff = 3,
    ShortingOffOpeningOn = 4,
    ShortingOnOpeningNoResp = 5,
    ShortingOffOpeningNoResp = 6,
    ShortingNoRespOpeningOn = 7,
    ShortingNoRespOpeningOff = 8,
    ShortingNoRespOpeningSwitch = 9,
    RevertTimeConditionMode = 10
}